// extracted by mini-css-extract-plugin
module.exports = {"container":"boxContainer_container__B6S_q","hide":"boxContainer_hide__HeIwd"};